<template>
    <div id="d2-pie-chart"></div>
</template>
<script>
import searchApi from '@/api/search.js'
let chart = null
// const width = window.innerWidth / 1920;
const colors = ['#f9d770', '#f8bc31', '#daa45a', '#4d4030', '#8e804b', '#fa7e23', '#ffa40f', '#954416', '#773d31', '#5d3131', '#a7535a', '#e3b4b8']
export default {
  name: 'index',
  data () {
     return {
        options: {
            title: '知识统计',
            data: []
        }
     }
  },
  methods: {
    setChart () {
      let data = this.options.data.map((item, index) => {
          let color = item.color
          return {
              value: item.value,
              name: item.name,
              itemStyle: {
                  color: color
              }
          }
      })
    //   const total = data.reduce((pre, cur) => {
    //     return pre + cur.value
    //   }, 0)
      const option = {
        tooltip: {
          trigger: 'item',
          textStyle: {
            fontSize: this.$isPhone ? 24 : 16
          }
        },
        legend: {
          icon: 'roundRect',
          textStyle: {
            fontSize: this.$isPhone ? 32 : 16
          }
        },
        grid: {
          bottom: 10,
          left: 0
        },
        series: [
          {
            name: '',
            type: 'pie',
            center: ['50%', '50%'],
            radius: ['25%', '75%'],
            avoidLabelOverlap: false,
            itemStyle: {
                borderWidth: 0,
                borderColor: '#333'
            },
            label: {
              show: false,
              position: 'center'
            //   formatter: [`{c|${this.options.title}}`, `{a|${total}}`].join('\n'),
            //   textStyle: {
            //     rich: {
            //       a: {
            //         color: '#666666',
            //         fontSize: 24 * width,
            //         lineHeight: 29 * width,
            //         fontFamily: 'FangZhengKaiTi-GBK'
            //       },
            //       // b: {
            //       //   color: '#666666',
            //       //   fontSize: 18 * width
            //       // },
            //       c: {
            //         color: '#666666',
            //         fontSize: 18 * width,
            //         lineHeight: 22 * width,
            //         fontFamily: 'FangZhengKaiTi-GBK'
            //       }
            //     }
            //   }
            },
            emphasis: {
              label: {
                show: true,
                fontSize: this.$isPhone ? 40 : 18,
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data: data
          }
        ]
      };
      chart.setOption(option)
    }
  },
  mounted () {
    chart = this.$echarts.init(document.getElementById('d2-pie-chart'), 'light');
    searchApi.selectFDCStatis().then(res => {
            let rows = res
            this.options.data = []
            for (let i = 0; i < rows.length; i++) {
                this.options.data.push({
                    name: rows[i].fdc, // 名称
                    value: rows[i].count, // 值
                    color: colors[(i + 2) % colors.length]
                })
            }
            this.setChart()
    })
    window.addEventListener('resize', () => {
      chart.resize();
    });
  }
}
</script>
<style lang="less" scoped>
@import "~@/styles/variables.less";
@import '~@/styles/variables.less';
#d2-pie-chart {
    width: 100%;
    height: 456px;
}
</style>
